<template>
    <div v-if="site && contract">
        <f-title title="Prüfungskosten" />

        <v-row class="no-frame ">
            <v-col class="no-frame mr-2 pt-1">
                <f-read-only-field
                    :label       = "$t('contract.zus.costsMainAudit')"
                    :value       = "contract.unit ? toMoney(contract.unit.mainAudit) : '---'"
                    :align-right = "true"
                    filled
                    dense
                />
            </v-col>
            <v-col class="no-frame ml-2 pb-2 pt-1">
                <f-read-only-field
                    :label       = "$t('contract.zus.costIntermediateAudit')"
                    :value       = "contract.unit ? toMoney(contract.unit.intermediateAudit) : '---'"
                    :align-right = "true"
                    filled
                    dense
                />
            </v-col>
        </v-row>

        <v-row class="no-frame ">
            <v-col class="no-frame mr-2 pt-1">
                <f-read-only-field
                    :label       = "$t('contract.zus.costAuditAfterDefects')"
                    :value       = "contract.unit ? toMoney(contract.unit.auditAfterDefects) : '---'"
                    :align-right = "true"
                    filled
                    dense
                />
            </v-col>
            <v-col class="no-frame ml-2 pb-2 pt-1">
                <f-read-only-field
                    :label       = "$t('contract.zus.costAuditAfterChange')"
                    :value       = "contract.unit ? toMoney(contract.unit.auditAfterChange) : '---'"
                    :align-right = "true"
                    filled
                    dense
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import FTitle from "@/modules/core/components/utils/FTitle";
import Core from "@/modules/core/service/Core";
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField";

export default {
    name: "CContractZusAbstract",
    components: {
        FReadOnlyField,
        FTitle
    },

    computed: {
        site () {
            return this.$store.getters.site;
        },

        contract () {
            if (!this.site["liftmanagement"]) {
                return null;
            }

            return this.site["liftmanagement"]["zusContract"];
        }
    },

    methods: {
        toMoney (number) {
            return Core.format.money (number);
        },
    }
}
</script>

<style scoped>

</style>